interface TenantDisabledProps {
  onClick: () => void
}

export const TenantDisabled = ({ onClick }: TenantDisabledProps) => {
  return (
    <>
      <h2 className='text-xl font-semibold mb-4'>Tenant Disabled</h2>
      <p className='text-gray-700 text-sm mb-4'>
        This tenant has been disabled. If you would like to make a request for
        data, or any other inquiries, please contact us at{' '}
        <a
          href='mailto:support@tokensoft.io'
          className='text-blue-600 underline'
        >
          support@tokensoft.io
        </a>
        .
      </p>
      <button
        onClick={onClick}
        className='float-right mt-2 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700'
      >
        Close
      </button>
    </>
  )
}
